import React from 'react'
import { Link } from 'react-router-dom'
import { injectIntl } from 'react-intl'

/*
 * Password reset moved to Single Login v2.
 *
 * Credentials are no longer stored by this app (the local bcrypt `users.password`
 * flow was removed with the Cognito migration), so there is nothing here to
 * reset. We send the user to the SSO app, which owns the Firebase account.
 */
function ForgotPassword() {
	const authAppUrl = process.env.REACT_APP_USER_MODULE_URL

	return (
		<div className='login-form text-center'>
			<div className='mb-10'>
				<h3 className='font-size-h1'>Forgotten Password?</h3>
			</div>

			<p className='opacity-80'>
				Your password is managed by SingleLogin. Reset it there and then sign
				back in to QuizApp.
			</p>

			<div className='form-group d-flex flex-wrap justify-content-center mt-10'>
				{authAppUrl && (
					<a
						href={authAppUrl}
						target='_blank'
						rel='noopener noreferrer'
						className='btn btn-primary font-weight-bold px-9 py-4 my-3 mx-2'
					>
						Reset password on SingleLogin
					</a>
				)}

				<Link
					to='/auth/login'
					className='btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-2'
				>
					Back to Sign In
				</Link>
			</div>
		</div>
	)
}

export default injectIntl(ForgotPassword)
